<template>
  <div v-if="showWhenEmpty || hasContent" class="field-display">
    <label class="field-display-label">{{ label }}</label>
    <div class="field-display-value">
      <slot><span class="text-pre">{{ displayValue }}</span></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldDisplay',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    showWhenEmpty: {
      type: Boolean,
      default: false,
    },
    emptyPlaceholder: {
      type: String,
      default: '-',
    },
  },
  computed: {
    hasValue() {
      return this.value !== null && this.value !== '';
    },
    hasContent() {
      return this.hasValue || !!this.$slots.default;
    },
    displayValue() {
      return this.hasValue ? this.value : this.emptyPlaceholder;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.field-display {
  margin-bottom: $layout-spacing;
  .field-display-label {
    display: block;
    font-weight: 600;
  }
  .field-display-value {
    margin-top: $border-width-lg;
    ul {
      margin-left: $layout-spacing-sm;
      li {
        margin: $border-width 0 0 0;
      }
      li:first-child {
        margin-top: 0;
      }
    }
    ul:first-child {
      margin-top: 0;
    }
    ul:last-child {
      margin-bottom: 0;
    }
    figure {
      margin: 0;
    }
  }
}
</style>
